function resolveFetch(fetchImpl) {
    if (fetchImpl) {
        return fetchImpl;
    }
    if (typeof fetch === 'function') {
        return fetch.bind(globalThis);
    }
    throw new Error('fetch is not available for CSRF renewal');
}
/** Re-runs app initialization so the backend reissues the CSRF cookie pair. */
export async function renewSessionCsrf(config) {
    const fetchFn = resolveFetch(config.fetchImpl);
    const initUrl = `${config.apiUri}/initialize`;
    try {
        const response = await fetchFn(initUrl, {
            method: 'GET',
            credentials: 'include',
            cache: 'no-store',
        });
        return response.ok;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=session-recovery.js.map